const addError = (field, errorMessage) => {
    const errorSpan = field.nextElementSibling
    field.classList.add('error-border')
    errorSpan.textContent = errorMessage
}

const removeError = (field) => {
    const errorSpan = field.nextElementSibling
    field.classList.remove('error-border')
    errorSpan.textContent = ''
}

export const validateString = (field) => {
    const value = field.value.trim()

    if (!value) {
        addError(field, 'Обязательное поле')
        return false
    } else if (value.length < 2) {
        addError(field, 'Минимум 2 символа')
        return false
    } else if (value.length > 255) {
        addError(field, 'Максимум 255 символов')
        return false
    } else {
        removeError(field)
        return true
    }
}

export const validatePhone = (field) => {
    const value = field.value.trim()
    const phoneRegex = /^\+375\s\(\d{2}\)\s\d{3}-\d{2}-\d{2}$/
    const operatorRegex = /^\+375\s\((29|33|44|25)\)/

    if (!value) {
        addError(field, 'Поле обязательно для заполнения')
        return false
    } else if (!phoneRegex.test(value)) {
        addError(field, 'Введите корректный номер в формате +375 (XX) XXX-XX-XX')
        return false
    } else if (!operatorRegex.test(value)) {
        addError(field, 'Неверный код оператора. Допустимые коды: 29, 33, 44, 25')
        return false
    } else {
        removeError(field)
        return true
    }
}

export const validateEmail = (field) => {
    const value = field.value.trim()
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!value) {
        addError(field, 'Поле обязательно для заполнения')
        return false
    } else if (!emailPattern.test(value)) {
        addError(field, 'Введите корректный email')
        return false
    } else if (value.length > 255) {
        addError(field, 'Максимум 255 символов')
        return false
    } else {
        removeError(field)
        return true
    }
}

export const validatePassword = (field) => {
    const value = field.value
    const passwordRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/

    if (!value) {
        addError(field, 'Поле обязательно для заполнения')
        return false
    }  else if (!passwordRegex.test(value) || /\s/.test(value)) {
        addError(field, 'Только латинские символы, цифры и спецсимволы')
        return false
    } else if (value.length < 5) {
        addError(field, 'Пароль должен содержать минимум 5 символов')
        return false
    } else if (value.length > 255) {
        addError(field, 'Максимум 255 символов')
        return false
    } else {
        removeError(field)
        return true
    }
}

export const validatePasswordRepeat = (field, passwordValue) => {
    const value = field.value

    if (!value) {
        addError(field, 'Поле обязательно для заполнения')
        return false
    } else if (value !== passwordValue) {
        addError(field, 'Пароли не совпадают')
        return false
    } else {
        removeError(field)
        return true
    }
}

export const validateCode = (field) => {
    const value = field.value.trim()
    
    if (!/^\d{4}-\d{4}$/.test(value)) {
        addError(field, 'Код должен быть в формате XXXX-XXXX');
        return false;
    } 

    removeError(field);
    return true;
}

export const validateUNP = (field) => {
    const value = field.value.trim()
    const unpRegex = /^\d{9}$/

    if (!value) {
        addError(field, 'Поле обязательно для заполнения')
        return false
    } else if (!unpRegex.test(value)) {
        addError(field, 'УНП должен содержать 9 цифр')
        return false
    }

    removeError(field)
    return true
}

export const validateBIC = (field) => {
    const value = field.value.trim()
    const bicRegex = /^[A-Z0-9]{8,11}$/

    if (!value) {
        addError(field, 'Поле обязательно для заполнения')
        return false
    }
    if (!bicRegex.test(value)) {
        addError(field, '8–11 символов (латиница и цифры)')
        return false
    }
    removeError(field)
    return true
}

// export const validateRegion = (field) => {
//     const value = field.value.trim()
//     const region = regions.find(region => region.name === value);

//     if (!value) {
//         addError(field, 'Выберите область')
//         return false
//     } else if (!region) {
//         addError(field, 'Выберите область из списка')
//         return false
//     } else {
//         removeError(field)
//         return true
//     }
// }

// export const validateCity = (field, currentRegion) => {
//     const value = field.value.trim()

//     if (!value) {
//         addError(field, 'Выберите город')
//         return false
//     }

//     const region = regions.find(region => region.name === currentRegion);

//     const cachedCities = localStorage.getItem(`cities_${region.id}`)
//     const cities = JSON.parse(cachedCities)
    
//     if (!cities.includes(value)) {
//         addError(field, 'Выберите город из списка')
//         return false
//     } else {
//         removeError(field)
//         return true
//     }
// }

// export const validateCity = (field) => {
//     const value = field.value.trim()

//     if (!value) {
//         addError(field, 'Введите населенный пункт')
//         return false
//     }

//     removeError(field)
//     return true
// }

// export const validateAddress = (field) => {
//     const value = field.value.trim()

//     if (!value) {
//         addError(field, 'Обязательное поле')
//         return false
//     } else if (value.length < 10) {
//         addError(field, 'Минимум 10 символов')
//         return false
//     } else if (value.length > 255) {
//         addError(field, 'Максимум 255 символов')
//         return false
//     } else {
//         removeError(field)
//         return true
//     }
// }

// export const validateBonuses = (field, maxValue) => {
//     const value = +field.value.trim()
    
//     if (value < 0) {
//         addError(field, 'Сумма не может быть отрицательной')
//         return false
//     } else if (value > maxValue) {
//         addError(field, `Доступно для списания: ${maxValue} руб.`)
//         return false
//     } else {
//         removeError(field)
//         return true
//     }
// }

